module.exports = __webpack_public_path__ + "img/preferences-page.b9716b5a.png";